export const STATUS_TYPES = {
  SUCCESS: 'success',
  FAILED: 'failure',
};

export const STATUS_CLASS_TYPES = {
  SUCCESS: 'active',
  FAILED: 'returned',
};
